<template>
  <div>
    <div>
    <b-nav class="main-nav">
    <b-nav-item class="logo">
    <img src="../assets/img/logo.png"/>
    </b-nav-item>
    </b-nav>
    </div>
    <div>
    <div class="main-div">
    <div class="login-div">
    <div class="profile-div col-11">
      <h5 class="mt-3 mb-3" v-if="isEmail" style="color:red;"> Email Already Exists </h5><br>
      <!-- <h5 class="mt-3 mb-3" style="word-wrap:break-word;"> Product Key:  {{productKey}} </h5><br>
      <h5 class="mt-3 mb-3" v-if="!isLicense" style="word-wrap:break-word;"> License Key:  {{licenseKey}} </h5><br> -->
      <b-table
          :fields="fields"
          :items="items"
          v-if=isLicense
          style="word-wrap:break-word;table-layout: fixed;">
          <template slot="licenseKey" slot-scope="data">
            <a title="Copy License to Clipboard" @click="copyLicense" style="cursor: pointer;" ref="license">
              {{data.value}}
            </a>
            <!-- <v-icon name="copy" base-class="icon-width"></v-icon> -->
          </template>
      </b-table><br><br>
      <input type="hidden" id="license-key" :value="licenseKey">
      <h5 class="mt-3 mb-3"> If you have any questions or require support please contact us on support@facitdatasystems.com </h5><br>
    </div>
</div>
</div>
</div>
  </div>
</template>

<script>
import API from '@/api';
import Session from '@/Session';
import VueRecaptcha from 'vue-recaptcha';
import FacitHeader from '@/components/header';

export default {
  name: 'licenseConfirmation',
  components: { FacitHeader },
  data() {
    const getProductKey = this.$route.query.productKey;
    const getLicenseKey = this.$route.query.licenseKey;
    const getIsEmail = this.$route.query.isEmail ? this.$route.query.isEmail : false;
    const getIsLicense = this.$route.query.isLicense ? true : false;
    return {
      productKey: getProductKey,
      licenseKey: getLicenseKey,
      isEmail: getIsEmail,
      isLicense: getIsLicense,
      items: [],
      fields: [
        {
          key: 'licenseKey',
          label: 'License Key',
        },
      ],
    };
  },
  created() {
    this.items.push({
      "licenseKey" : this.licenseKey,
      "productKey" : this.productKey
    })
},
  methods: {
    async copyLicense() {
      let licenseKeyCopy = document.querySelector('#license-key')
          licenseKeyCopy.setAttribute('type', 'text')
          licenseKeyCopy.select()
      try {
            document.execCommand('copy');
            await this.$notify({
              group: 'sitewide',
              title: 'Success!',
              type: 'success',
              text: 'License Copied Successfully',
            });
          } catch (err) {

          }
      licenseKeyCopy.setAttribute('type', 'hidden')
      window.getSelection().removeAllRanges()
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.profile-div {
  margin-top: 50px;
  margin-left: 50px;
}
.btn-warning {
  color: #fff;
  background-color: #ff8f00;
  border-color: #ff8f00;
}
.help.is-danger {
    color: #ff3860;
}
.help {
    display: block;
    font-size: 11px;
    margin-top: 5px;
}
span {
    font-style: inherit;
    font-weight: inherit;
}
*, :after, :before {
    box-sizing: inherit;
}
.main-nav {
  background-color: #2c3e50 !important;
  height: 90px;
}
.main-div {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100vh;
  margin: auto;
}

.login-div {
  background-color: white;
  width: 100%;
  height: 260px;
}
.logo {
  margin-top: 20px;
  margin-left: 30px;
}
.icon-width {
  width: 20px !important;
  height: 20px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/licenseConfirmation.vue